<template>
  <el-container class="list" key="" :style="{height:setPx(height)}">
    <el-aside width="180px">
      <ul class="menu">
        <li :index="item.id"
            :key="item.id"
            v-for="item in typeList"
            :class="{'is-active':item.id===activeName}"
            @click="handleSelect(item)">
          <i :class="item.icon"></i>
          {{item.name}}
        </li>
      </ul>
    </el-aside>
    <el-container>
      <router-view></router-view>
    </el-container>
  </el-container>
</template>
<script>

import {getUserPermissionList} from '@/page/system/api/user';
export default {
  name: "System",

  data () {
    return {
      height: 0,
      typeList: [],
      box: false,
 
      form: {},
      activeName: '',
      list: [],
    }
  },
  created () {
    this.getMenuList()
  },
  mounted () {
    this.height = document.body.clientHeight - 230
  },
  methods: {

    getMenuList() {
      getUserPermissionList().then(res => {
          if (res.data.success) {
              let list = res.data.data
            list.forEach(e => {
              if(e.path ==='/system') {
                this.typeList =  e.childs
                this.activeName = sessionStorage.getItem("daping_system_active")||this.typeList[0].id;
              }
            })
          }
        });
    },
    handleSelect (key) {
      this.$router.push(key.path)
      this.activeName = key.id;
      sessionStorage.setItem("daping_system_active",key.id)
    },

  }
}
</script>
<style lang="scss">
@import "@/styles/list.scss";

.table {
  width: 100%;
}
.el-container{
  padding: 0 5px;
}
</style>
